import { render } from "./MainThietBi.vue?vue&type=template&id=ff5df0d8&scoped=true"
import script from "./MainThietBi.vue?vue&type=script&lang=js"
export * from "./MainThietBi.vue?vue&type=script&lang=js"

import "./MainThietBi.vue?vue&type=style&index=0&id=ff5df0d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5df0d8"]])

export default __exports__